import { WhyNeedSection } from './view';
export default WhyNeedSection;
